<template>
  <main>
    <system-communications-email-editor
      v-if="content.htmlContent"
      :value="content"
      :email="email"
      :type="emailType"
      :email-variables="emailVariables"
      :is-editable="isEmailEditable"
      @input="setEmailContent"
      @config="openConfigModal"
    />
    <system-communications-email-config-modal
      :showing.sync="showConfigModal"
      :closeable="true"
      :config="config"
      @update-config="setEmailConfig"
    />
    <confirmation-modal
      :value="showingVariablesDisclaimer"
      :confirm-label="$t('message.email.message.systemCommunicationsEmailModalConfirmationButton')"
      :max-width="550"
      is-only-one-button
      @confirm="closeVariablesDisclaimer"
    >
      <span slot="heading"> {{ $t('message.email.message.systemCommunicationsEmailVariable') }}</span>
      <div class="aditional-fee-text-wrapper">
        <span>
            {{ $t('message.email.message.systemCommunicationsEmailModalConfirmation') }}
          <br />
          <br />
          <span v-html="$t('message.email.message.systemCommunicationsEmailModalConfirmationHtml')"></span>
        </span>
      </div>
    </confirmation-modal>
  </main>
</template>
<script>
import SystemCommunicationsEmailEditor from "@components/modules/system-communications/email/editor/SystemCommunicationsEmailEditor";
import SystemCommunicationsEmailConfigModal from "@components/modules/system-communications/email/config/modal/SystemCommunicationsEmailConfigModal";
import ConfirmationModal from "@components/ConfirmationModal.vue";
import EventBus from "@packages/event-bus";

export default {
  components: {
    SystemCommunicationsEmailEditor,
    SystemCommunicationsEmailConfigModal,
    ConfirmationModal,
  },

  data() {
    return {
      emailType: undefined,
      isEmailEditable: false,
      showConfigModal: false,
      viewOnly: false,
      email: {
        id: "",
        subject: "",
        content: "",
        rawContent: "",
        cssStyle: "",
        brief: "",
        senderName: "",
        senderEmail: "",
      },
      genericEmailVariables: [
        {
          title: "Nome do destinatário",
          htmlContent:
            "<div style='max-width: 250px; font-size: 12px'><span>Para colocar o nome do destinatário ao qual você está enviando o e-mail, é só <strong>inserir a variável {PRIMEIRO_NOME}</strong> na mensagem. Clique no botão para copiá-la.</span></div>",
          variable: "{PRIMEIRO_NOME}",
        },
        {
          title: "Definição de senha",
          htmlContent:
            "<div style='max-width: 250px; font-size: 12px'><span>É obrigatório que e o e-mail de boas vindas contenha o link para definição de uma senha de acesso para o novo usuário cadastrado. <strong>Utilize a variável {DEFINIR_SENHA}</strong> no corpo do e-mail para indicar onde o link será adicionado. Clique no botão para copiá-la.</span></div>",
          variable: "{DEFINIR_SENHA}",
        },
        {
          title: "Email do usuário",
          htmlContent:
            "<div style='max-width: 250px; font-size: 12px'><span><strong>Utilize {EMAIL_USUARIO}</strong> para inserir o e-mail do destinatário no corpo da mensagem.</span></div>",
          variable: "{USUARIO_EMAIL}",
        }
      ],
      passwordRecoveryEmailVariables: [
        {
          title: "Invalidar recuperação",
          htmlContent:
            "<div style='max-width: 250px; font-size: 12px'><span>É obrigatório que e o e-mail de recuperação de senha contenha o link para invalidação de recuperação, o qual, quando clicado, cancelará o processo de recuperação. <strong>Utilize a variável {INVALIDAR}</strong> no corpo do e-mail para indicar onde o link será adicionado. Clique no botão para copiá-la.</span></div>",
          variable: "{INVALIDAR}",
        },
        {
          title: "Endereço de IP",
          htmlContent:
            "<div style='max-width: 250px; font-size: 12px'><span>É obrigatório que e o e-mail de recuperação de senha contenha o endereço de IP do destinatário. <strong>Utilize a variável {ENDERECO_IP}</strong> no corpo do e-mail para indicar onde o endereço de IP será adicionado. Clique no botão para copiá-la.</span></div>",
          variable: "{ENDERECO_IP}",
        }
      ],
      showingVariablesDisclaimer: false,
    };
  },

  computed: {
    content() {
      return {
        htmlContent: this.email.rawContent,
        cssStyle: this.email.cssStyle,
      };
    },
    config() {
      return {
        brief: this.email.brief,
        senderEmail: this.email.senderEmail,
        senderName: this.email.senderName,
        subject: this.email.subject,
      };
    },
    isPasswordRecoveryEmail() {
      return this.emailType === "password-recovery";
    },
    emailVariables() {
      let variables = this.genericEmailVariables;
      if (this.isPasswordRecoveryEmail) {
        variables.push(...this.passwordRecoveryEmailVariables);
      }
      return variables;
    },
  },

  methods: {
    setEmailType() {
      const pathname = window.location.pathname;
      const emailType = pathname.split("/").pop();
      this.emailType = emailType;
    },
    returnToSystemCommunicationsPage() {
      this.$router.push({
        path: "/system-communications",
      });
    },
    openConfigModal() {
      this.showConfigModal = true;
    },
    closeConfigModal() {
      this.showConfigModal = false;
    },

    async getEmail() {
      try {
        const data = await this.$api.core.partner.systemCommunications.get(
          this.emailType
        );

        this.email = data;
      } catch (error) {
        EventBus.$emit("show-message", {
          type: "ERROR",
          message: "Não foi possível buscar as informações do email",
        });
        this.returnToSystemCommunicationsPage();
      }
    },

    async setEmailConfig(updatedConfig) {
      this.email.brief = updatedConfig.brief;
      this.email.senderEmail = updatedConfig.senderEmail;
      this.email.senderName = updatedConfig.senderName;
      this.email.subject = updatedConfig.subject;
      this.email.title = updatedConfig.title;
      this.saveContent();
      this.closeConfigModal();
    },

    async setEmailContent(data) {
      this.email.rawContent = data.htmlContent;
      this.email.cssStyle = data.cssStyle;
    },

    async saveContent() {
      EventBus.$emit("SHOW_SPINNER");
      try {
        await this.$api.core.partner.systemCommunications.edit({
          type: this.emailType,
          data: { ...this.email },
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.emailUpdated')
        });

        EventBus.$emit("TEMPLATE_COMPILE");
      } catch (error) {
        EventBus.$emit("show-message", {
          type: "ERROR",
          message: error.response.data.message ? error.response.data.message : "Erro ao salvar as alterações",
        });
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },

    showVariablesDisclaimer() {
      const userHasSeenVariablesDisclaimer = localStorage.getItem(
        `userHasSeenVariablesDisclaimer-${this.emailType}`
      );
      if (!userHasSeenVariablesDisclaimer) {
        this.showingVariablesDisclaimer = true;
      }
    },
    closeVariablesDisclaimer() {
      localStorage.setItem(
        `userHasSeenVariablesDisclaimer-${this.emailType}`,
        true
      );
      this.showingVariablesDisclaimer = false;
    }
  },

  created() {
    this.setEmailType();
    this.showVariablesDisclaimer();
  },

  mounted() {
    this.getEmail(this.emailType);

    EventBus.$on("SAVE_CONTENT", this.saveContent);
    EventBus.$on("EDIT_CONTENT", () => (this.isEmailEditable = true));
  },

  beforeDestroy() {
    EventBus.$off("SAVE_CONTENT", this.saveContent);
    EventBus.$off("EDIT_CONTENT", () => (this.isEmailEditable = true));
  },
};
</script>
<style lang="scss" scoped></style>
